// @flow

import * as React from 'react';

// Libs
import { StyleSheet, css } from 'aphrodite';

type Props = {
  currentTime: number,
};

const VideoProgressBarTime = ({ currentTime }: Props): React.Node => (
  <div className={css(styles.root)}>
    <p className={css(styles.text)}>
      {(Math.round(currentTime) / 100).toFixed(2)}
    </p>
  </div>
);

const styles = StyleSheet.create({
  root: {
    marginLeft: -12,
    marginTop: -16,
    position: 'absolute',
  },
  text: {
    '-webkit-user-select': 'none',
    '@media screen and (max-width: 414px)': {
      fontSize: '20px',
    },
    '@media screen and (min-width: 2000px)': {
      fontSize: '26px',
      lineHeight: '30px',
    },
    color: '#FFF',
    fontFamily: 'UniversLight',
    fontSize: '22px',
  },
});

export default VideoProgressBarTime;
